import _ from "lodash";
import React from "react";
import { store } from "store/createStore";
import {
  FEED_TYPE,
  FEED_CHILD_HEADER_SUBTEXT,
  MODULES,
  PERMISSION_STATUS_DROPDOWN_OPTIONS,
} from "./constants";
import ACLStore from "lib/aclStore";

export const getOrganizationCurriculumPrograms = () => {
  const state = store?.getState() ?? {};
  const orgCurriculumPrograms = _.get(
    state,
    "platform.organizationCurriculumPrograms"
  );
  return orgCurriculumPrograms;
};

export const getCurriculumProgramById = curriculumId => {
  if (!curriculumId) return {};
  const orgCurriculumPrograms = getOrganizationCurriculumPrograms();
  const curriculumProgram = _.find(orgCurriculumPrograms, {
    id: curriculumId,
  });
  return curriculumProgram;
};

export const getChildHeaderSubtext = ({ t, feedKey, curriculumProgramId }) => {
  const { acronym = "" } = getCurriculumProgramById(curriculumProgramId);
  switch (feedKey) {
    case FEED_TYPE.ADMINISTRATORS:
      return t(FEED_CHILD_HEADER_SUBTEXT[feedKey]);
    case FEED_TYPE.TEACHERS:
      if (!acronym) return "";
      return t(_.get(FEED_CHILD_HEADER_SUBTEXT, [feedKey]), { acronym });
    default:
      return "";
  }
};

export const getModulesAccessStatus = _.memoize(modulesAccessObj => {
  const moduleAccessStatus = [];
  _.forEach(modulesAccessObj, (access, module) => {
    if (
      MODULES[module] &&
      !_.includes(modulesAccessObj.disabledColumns, module)
    ) {
      moduleAccessStatus.push({
        module,
        value: access,
        hasDefaultAccess: MODULES[module]?.default_value === access,
        hasHighestAccess: MODULES[module]?.highest_value === access,
      });
    }
  });
  return moduleAccessStatus;
}, JSON.stringify);

export const getModuleAccessLevels = _.memoize(module => {
  const accessValues = _.entries(MODULES[module].values);
  const valuesDetails = _.map(
    accessValues,
    ([accessKey, accessValue], index) => {
      return {
        ...accessValue,
        displayOrder: index,
      };
    }
  );
  return valuesDetails;
}, JSON.stringify);

export const getModuleLevelAccessOptions = ({
  t,
  module,
  curriculumAcronym,
  curriculumType,
  behaviourNomenclatureConstants,
}) => {
  return _.map(getModuleAccessLevels(module), accessInfo => {
    const {
      id,
      labelLocale,
      descriptionLocale,
      descriptionLocaleProps = [],
      getDescriptionLocale,
      Icon,
    } = accessInfo;

    let localesText = _.get(
      descriptionLocale,
      curriculumType,
      descriptionLocale
    );

    if (_.isFunction(getDescriptionLocale)) {
      localesText = getDescriptionLocale(ACLStore);
    }

    const localeParams = {
      curriculum: curriculumAcronym,
      incident: behaviourNomenclatureConstants.INCIDENT,
      action: behaviourNomenclatureConstants.ACTION,
      level: behaviourNomenclatureConstants.LEVEL,
      module: behaviourNomenclatureConstants.MODULE,
    };

    const subText = !_.isEmpty(descriptionLocaleProps)
      ? t(localesText, _.pick(localeParams, descriptionLocaleProps))
      : t(localesText);

    return {
      key: id,
      value: id,
      label: t(labelLocale),
      subText: subText,
      icon: <Icon />,
    };
  });
};

export const getDefaultAccessOptions = ({ t, curriculumAcronym }) => {
  return _.map(PERMISSION_STATUS_DROPDOWN_OPTIONS, accessInfo => {
    const { id, labelLocale, descriptionLocale, Icon } = accessInfo;
    const subText = t(descriptionLocale, { curriculum: curriculumAcronym });
    return {
      key: id,
      label: t(labelLocale),
      subText: subText,
      icon: <Icon />,
    };
  });
};
